import { tv } from 'tailwind-variants';

import { createEnumVariants } from '../../../utils/commonTailwindVariants.utils';
import { Size } from '../constants';

import { HugeIconSize } from './HugeIcons';

export const hugeIconStyles = tv({
  base: 'relative',
  variants: {
    size: createEnumVariants<typeof Size, HugeIconSize>({
      [Size.MEDIUM]: 'p-4 [&>svg]:h-16 [&>svg]:w-16',
      [Size.LARGE]: 'p-4 [&>svg]:h-20 [&>svg]:w-20'
    }),
    invert: {
      true: 'rotate-180'
    },
    gridBackground: {
      true: 'bg-[linear-gradient(90deg,rgb(26_26_26)_1px,transparent_1px),linear-gradient(180deg,rgb(26_26_26)_1px,transparent_1px)] bg-[size:9px_9px]'
    },
    backgroundPosition: createEnumVariants<typeof Size, HugeIconSize>({
      [Size.MEDIUM]: 'bg-[-6px_-6px]',
      [Size.LARGE]: 'bg-[-12px_-12px]'
    })
  },
  compoundVariants: [
    {
      size: Size.MEDIUM,
      gridBackground: true,
      class: 'bg-[-6px_-6px]'
    },
    {
      size: Size.LARGE,
      gridBackground: true,
      class: 'bg-[-12px_-12px]'
    }
  ]
});
